import {
   useMutation,
} from "@tanstack/react-query";

import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Estado } from '../../actions/Estado'
import style from "../../styles/form.module.css";

function ABMPagos() {
   const token = localStorage.getItem("token");   
   const url = process.env.REACT_APP_URL_DIR + "formaspago";
   var urlPago = url
   var metodo = "POST"
   // const urlProd = process.env.REACT_APP_URL_DIR + "estadosproducto";
   const estados =  Estado();
   // const queryClient = useQueryClient();

   const location = useLocation();
   const { state } = location;
   const navigate = useNavigate();
   const [input, setInput] = useState({
      id_primary: state ? state.id_primary : 0,
      id: state ? state.id : 0,
      companyId: state ? state.companyId : 0,
      descripcion: state ? state.descripcion : "",
      recargo: state ? state.recargo : "",
      cod_status: state ? state.cod_status : "1",
   });

   var btnGrabar = true;

   function handleChange(e) {
      e.preventDefault();
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      console.log("handleSubmit : ", input);
      urlPago = url + `/${input.id}`
      metodo = "PUT"
      if (input.id ===0) {
         urlPago = url 
         metodo = "POST"
      }
      console.log('input: ', input);
      mutate(input)
      //navigate("/pagos")
      window.location.href = "/pagos";

   };

   const { mutate} = useMutation({
      mutationFn: (newPost) =>
         fetch(urlPago,
            {
               method: metodo,
               body: JSON.stringify(newPost),
               headers: {
                  "Authorization": `Bearer ${token}`,
                  "Content-Type": "application/json",
               },
            }).then((res) => res.json()),
            onSuccess: () => {
            //window.location.href = "/pagos";
         },
         onError:(error)=>{
            console.log('error: ', error);
            alert('Error')
         }
   });

   //console.log("input: ", input);
   // return (
   //    <>
   //       <div className="container">HOLA
   //       </div>
   //    </>
   // );

console.log('input: ', input);
   return (
      <>
         <div className={style.container}>
            <div className="bg-white w-90">
               <form
                  onSubmit={(e) => handleSubmit(e)}
                  // className="form-style-Prod"
               >
                  <h1 className="justify-self-center">Datos del Pago</h1>
                  <br />
                  {/* <div>
                     {input.id !== 0 ? (
                        <div>
                           <span className={style.input_group_text}>
                              Pago id : {input.id}
                           </span>
                           <br />
                        </div>
                     ) : null}
                  </div> */}

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Descripcion: </span>
                     <input
                        className={style.input_field}
                        type="text"
                        placeholder="Ingrese descripcion del Pago"
                        name="descripcion"
                        value={input.descripcion}
                        onChange={handleChange}
                        required
                     />
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Recargo: </span>
                     <input
                        className={style.input_field_number}
                        type="text"
                        placeholder="Ingrese Recargo"
                        name="recargo"
                        value={input.recargo}
                        onChange={handleChange}
                        required
                     />&nbsp;%
                  </div>

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Status:</span>
                     <select
                        name="cod_status"
                        id="cod_status"
                        onChange={(e) => handleChange(e)}
                        value={input.cod_status}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {estados &&
                           estados.map((dat) => {
                                 return (
                                    <option
                                       selected
                                       value={dat.id}
                                       key={dat.id}
                                    >{`${dat.nombre}`}</option>
                              )   }
                           )}{" "}
                     </select>
                  </div>
                  <div>
                     {btnGrabar ? (
                        <button className={style.inputBtnNew} type="submit">
                           {state ? "GRABAR" : "AGREGAR"}
                        </button>
                     ) : null}
                     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                     <button
                        className={style.inputBtnNew}
                        onClick={() => {
                           navigate("/pagos");
                        }}
                     >
                        VOLVER
                     </button>
                  </div>
               </form>
            </div>
         </div>
      </>
   );
}

export default ABMPagos;
